module.exports = __webpack_public_path__ + "0bc23418cf7a453885cf44eb911ca371.svg";